module.exports = __webpack_public_path__ + "static/media/esquenta-2-por-1.4bcb266d.png";